






































































































































































































import { Component, PropSync, Vue, Watch } from 'vue-property-decorator'

const validateUrl = (string = '') => {
  if (!string.startsWith('http://') || !string.startsWith('https://')) {
    string = 'https://' + string
  }
  try {
    const url = new URL(string);
    return url.href.replace(/\/$/, '')
  } catch (_) {
    return false
  }
}

const counterhelper = (() => {
  let i = 0
  return () => i++
})()

@Component({})
export default class SettingsDrawer extends Vue {
  @PropSync('open') show !: boolean;

  // If Vetur was working correctly, the following two `: { password: string; url: string }` would be unnecceasiry. Added them to soothe vs-code’s concerns.
  iservers = this.$store.state.servers.map(({ password, url }: { password: string; url: string }) => ({ id: this.counter(), valid: false, show: false, password, url }));

  onServersChanged () {
    this.iservers = this.$store.state.servers.map(({ password, url }: { password: string; url: string }) => ({ id: this.counter(), valid: false, password, url }));
  }

  counter () {
    return counterhelper()
  }

  urlRules: FormRule[] = [
    v => !!v || 'URL is required',
    v => {
      const temp = validateUrl(v)
      if (temp) {
        return true
      }
      return 'URL has to be valid'
    },
  ]

  passwordRules: FormRule[] = [
    v => !!v || 'Password is required',
  ]

  save (index: number, { url, password, valid }: { url: string; password: string; valid: true }) {
    // console.log(index, url, valid)
    if (valid) {
      this.$emit('save', { index, url, password })
    }
  }

  remove (index: number) {
    this.$emit('delete', index)
  }

  addRow () {
    this.iservers.push({
      id: this.counter(),
      password: '',
      url: '',
      valid: false
    })
  }

  isModified (server: { id: number; valid: boolean; password: string; url: string }, i: number) {
    return (!this.$store.state.servers[i] || !this.$store.state.servers[i].url || !this.$store.state.servers[i].password || this.$store.state.servers[i].url !== server.url || this.$store.state.servers[i].password !== server.password)
  }

  get viewSettingsDark () {
    return this.$store.state.viewSettings.darkMode
  }

  set viewSettingsDark (v: boolean) {
    this.$store.commit('viewSettings', { darkMode: v })
  }

  get viewSettingsGrid () {
    return this.$store.state.viewSettings.grid
  }

  set viewSettingsGrid (v: boolean) {
    this.$store.commit('viewSettings', { grid: v })
  }

  get viewSettingsDense () {
    return this.$store.state.viewSettings.dense
  }

  set viewSettingsDense (v: boolean) {
    this.$store.commit('viewSettings', { dense: v })
  }

  downloadingBackup: { [url: string]: [boolean, boolean] } = {}
  downloadingRDF: { [url: string]: [boolean, boolean] } = {}

  downloadBackup (serverUrl: string) {
    Vue.set(this.downloadingBackup, serverUrl, true)
    const url = ((serverUrl.startsWith('https://') || serverUrl.startsWith('http://')) ? serverUrl : 'https://' + serverUrl) + '/raw/zip'
    const options = {
      headers: {
        Authorization: this.$store.getters.server.server.headers.get('Authorization')
      }
    }

    fetch(url, options)
      .then(r => r.blob())
      .then(b => {
        Vue.set(this.downloadingBackup, serverUrl, false)
        const link = document.createElement('a')
        link.href = URL.createObjectURL(b)
        link.download = 'tridoc_backup_' + Date.now() + '.zip'
        link.click();
      })
  }

  downloadRDF (serverUrl: string) {
    Vue.set(this.downloadingRDF, serverUrl, true)
    const url = ((serverUrl.startsWith('https://') || serverUrl.startsWith('http://')) ? serverUrl : 'https://' + serverUrl) + '/raw/rdf'
    const options = {
      headers: {
        Authorization: this.$store.getters.server.server.headers.get('Authorization')
      }
    }

    fetch(url, options)
      .then(r => r.blob())
      .then(b => {
        Vue.set(this.downloadingRDF, serverUrl, false)
        const link = document.createElement('a')
        link.href = URL.createObjectURL(b)
        link.download = 'tridoc_backup_' + Date.now() + '.ttl'
        link.click();
      })
  }

  // PWA INSTALLATION
  installable: (Event|false) = false

  install () {
    (this.installable as any).prompt();
    (this.installable as any).userChoice.then((r: any) => {
      if (r.outcome === 'accepted') {
        this.installable = false
      }
    })
  }

  mounted () {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.installable = e
    })
  }
}
